export const getAbbreviatedSeatsOption = (seatCharacteristics = []) => {
  const hasCharacteristic = (seatType) =>
    seatCharacteristics.some((characteristic) => characteristic?.includes(seatType));
  let abbreviatedSeatName = "standard";

  if (hasCharacteristic("EXIT_ROW")) {
    abbreviatedSeatName = "exit";
  } else if (hasCharacteristic("LEG_SPACE") || hasCharacteristic("EXTRA_LEGROOM")) {
    abbreviatedSeatName = "elr";
  } else if (hasCharacteristic("PREFERRED")) {
    abbreviatedSeatName = "premium";
  }

  return abbreviatedSeatName;
};
